export class StatusEnum {
  static APPROVED = 'approved';
  static PENDING = 'pending';
  static IN_PROCESS = 'in progress';
  static DENIED = 'denied';
  static OPEN = 'open';
  static CLOSE = 'close';
  static DELETE = 'delete';
}
